// assets/graphql.js

const storeDomain = '89th-madison.myshopify.com';  // Liquid 渲染店铺域名
const storefrontAccessToken = '7b45a3978255624d97a2469cf314ae26';  // 你自己替换

async function fetchProducts(cursor = null, value_list = '') {
  const query = `
query getProducts($cursor: String) {
  products(first: 50, after: $cursor) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        title
        handle
        description
        publishedAt
        createdAt
        vendor
        productType
        tags
        priceRange {
          minVariantPrice {
            amount
            currencyCode
          }
          maxVariantPrice {
            amount
            currencyCode
          }
        }
        variants(first: 50) {
          edges {
            node {
              id
              title
              sku
              availableForSale
              priceV2 {
                amount
                currencyCode
              }
              selectedOptions {
                name
                value
              }
              image {
                src
                altText
              }
            }
          }
        }
        images(first: 10) {
          edges {
            node {
              src
              altText
            }
          }
        }
        featuredImage {
          src
          altText
        }
      }
    }
  }
}
`;


  const variables = { cursor };

  const res = await fetch(`https://${storeDomain}/api/2023-07/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
    },
    body: JSON.stringify({ query, variables }),
  });

  const json = await res.json();
  return json.data.products;
}
